document.querySelectorAll('[data-card-teaser]').forEach(card => {


      // Add an event listener for when the mouse moves over the card
      card.addEventListener('mousemove', (e) => {
        // Get the card's size and position relative to the viewport
        const cardRect = card.getBoundingClientRect();

        // Calculate the position of the mouse relative to the card's top-left corner
        const x = e.clientX - cardRect.left;
        const y = e.clientY - cardRect.top;

        // Find the center of the card
        const centerX = cardRect.width / 2;
        const centerY = cardRect.height / 2;

        const rotateX = ((y - centerY) / centerY) * -3;
        const rotateY = ((x - centerX) / centerX) * 3;

        // Apply the calculated rotation to the card
        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      });

      // Add an event listener for when the mouse leaves the card area
      card.addEventListener('mouseleave', () => {
        // Reset the card's rotation when the mouse leaves
        card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';
      });
    });
